<template>
  <v-card>
    <ac-data-table
      :headers="headerVisible(headers)"
      :items="headerFilter(items)"
      :item-class="row_class"
      hide-default-footer
      disable-pagination
      sort-by="name"
      item-key="uid"
      fixed-header
      :height="winsize.height - 145"

      :search.sync="search"
      v-model="selected"

      :can-select="item => !row_readonly(item)"
      :can-delete="item => !row_readonly(item)"
      :remove-bulk="bulkRemove"
      :bulk-mode.sync="bulkMode"

      title="Tutorials"
    >
      <template #actions>
        <v-btn @click="row_create" class="ma-2" color="primary">
          New Tutorial
        </v-btn>
        <v-btn @click="show_preview" class="ma-2" color="accent">
          Preview JSON
        </v-btn>
      </template>

      <template v-for="(header,index) in headers" v-slot:[`header.${header.value}`]>
        <span v-if="header.filters" :key="index+header">
          {{ header.text }}
           <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon small :color="header.filters.length ? 'primary' : ''">
                    mdi-filter-variant
                  </v-icon>
                </v-btn>
              </template>
              <div style="background-color: white; width: 280px">
                <v-list>
                  <v-list-item>
                      <v-autocomplete
                        v-model="header.filters"
                        :items="headerFilterValues(header)"
                        label="Select filters"
                        class="mt-3"
                        chips small-chips
                        auto-select-first
                        multiple dense
                        color="light-blue lighten-3"
                        append-icon="mdi-filter">
                            <template v-slot:selection="data">
                              <v-chip
                                v-bind="data.attrs"
                                :input-value="data.selected"
                                close small class="ma-1"
                                @click="data.select"
                                @click:close="headerFilterRemove(header,data.item)"
                              >
                                {{ data.item }}
                              </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <v-list-item-content v-text="data.item"/>
                            </template>
                      </v-autocomplete>
                  </v-list-item>
                </v-list>
              </div>
            </v-menu>
        </span>
        <span v-else :key="header+index">
          {{ header.text }}
        </span>
      </template>

      <template v-slot:item.v2="{item}">
        <div align="center">{{ item.v2 ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.master="{item}">
        <div align="center">{{ item.master ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.showNext="{item}">
        {{ getShowNext(item) }}
      </template>

      <template v-slot:item.enabled="{item}">
        <div align="center">{{ item.enabled ? "ON" : "OFF" }}</div>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon v-if="row_readonly(item)" @click="row_view(item)" class="mr-2" small color="green">
          mdi-eye
        </v-icon>
        <v-icon v-else-if="item.locked" @click="row_update(item)" class="mr-2" small color="orange">
          mdi-pencil
        </v-icon>
        <v-icon v-else @click="row_update(item)" class="mr-2" small color="green">
          mdi-pencil
        </v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small color="teal lighten-1">
          mdi-content-copy
        </v-icon>
        <v-icon :disabled="item.global || item.shared" @click="row_export(item)" class="mr-2" small color="blue">mdi-briefcase-upload</v-icon>
        <v-icon :disabled="row_readonly(item)" @click="row_remove(item)" class="mr-2" small color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" color="blue-grey" dense>
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </ac-data-table>

    <r-tutorial-dialog ref="dialog"/>
    <r-dialog-preview-collection ref="previewCollection"/>
  </v-card>
</template>

<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";
import {TutorialModel} from "@/modules/redactor/models/tutorial/TutorialModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {getObjectValueByPath} from "vuetify/lib/util/helpers";
import RTutorialDialog from "@/modules/redactor/views/tutorial/r-tutorial-dialog";
import AcDataTable from "@/components/Table/ac-data-table.vue";
import RDialogPreviewCollection from "@/modules/redactor/views/preview/r-preview-collection-dialog.vue";


export default {
  name: "r-tutorial-page",
  components: {RDialogPreviewCollection, AcDataTable, RTutorialDialog},
  data: () => ({
    search: "",
    headers: [
      {text: "ID", value: "id"},
      {text: "V2", value: "v2"},
      {text: "Name", value: "name"},
      {text: "Kind", value: "kind.name", filters: []},
      {text: "Master", value: "master"},
      {text: "DelayOnShow", value: "delayOnShow"},
      {text: "Show Next", value: "showNext"},
      {text: "Status", value: "enabled"},

      {text: "UID", value: "uid"},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ],
    items: {
      type: VueTypes.arrayOf(TutorialModel)
    },
    selected: [],
    bulkMode: false,
    pagination: {rowsPerPage: 100}
  }),
  computed: {
    masterAccess() {
      return RedactorUtils.hasMasterAccess();
    },
    winsize() {
      return window.app.winsize;
    }
  },
  methods: {
    row_view(item) {
      this.$refs['dialog'].show(ViewRules.READONLY, item.clone()).catch(() => {

      });
    },
    row_copy(talk) {
      this.$refs['dialog'].show(ViewRules.COPY, talk.copy()).then(
          result => {
            RedactorUtils.pushTutorial(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE, null).then(
          result => {
            RedactorUtils.pushTutorial(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_update(talk) {
      this.$refs['dialog'].show(ViewRules.UPDATE, talk.clone()).then(
          result => {
            RedactorUtils.pushTutorial(result).then(
                () => {
                  this.$alert("Changes was published");
                });
          }, () => {
          });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        RedactorUtils.removeTutorial(item).then(
            () => {
              this.$alert("Changes was published");
            });
      });
    },

    bulkRemove(items) {
      return RedactorUtils.removeBulkTutorials(items);
    },

    row_export(item) {
      let result = item.clone();
      result.export = !item.export;
      RedactorUtils.pushTutorial(result);
    },
    row_class(item) {
      if (item.shared) {
        return "yellow lighten-4"
      } else if (item.global) {
        return "cyan lighten-4"
      } else if (item.export) {
        return "green lighten-3"
      } else if (item.changed) {
        return "blue lighten-3"
      } else if (!item.enabled) {
        return "blue-grey lighten-3"
      }
    },
    row_readonly(item) {
      return (item.locked && !this.masterAccess) || item.global || item.shared;
    },

    getShowNext(item) {
      let tutorial = RedactorUtils.getTutorial(item.showNext);
      return tutorial ? tutorial.name : "-";
    },

    headerFilter(items) {
      let hh = this.headers.filter(h => {
        return h.filters && h.filters.length > 0
      });

      if (hh.length === 0) {
        return items;
      } else {
        return items.filter(item => {
          return hh.every(header => {
            let value = getObjectValueByPath(item, header.value);
            if (!value) {
              return false;
            }

            let text = value.toString().toLocaleLowerCase();
            return header.filters.some(v => {
              return text.includes(v.toString().toLocaleLowerCase());
            });
          });
        });
      }
    },
    headerFilterValues(header) {
      let values = this.items.map(item => {
        return getObjectValueByPath(item, header.value);
      });
      let unique = [...new Set(values.filter(v => v))];
      return unique;
    },
    headerFilterRemove(header, filter) {
      const index = header.filters.indexOf(filter)
      if (index >= 0) header.filters.splice(index, 1)
    },
    headerVisible(headers) {
      return headers.filter(h => {
        return h.visible === true || h.visible === undefined;
      });
    },
    show_preview() {
      this.$refs['previewCollection'].show(this.items, TutorialModel, "tutorial")
          .then(() => this.$alert("Changes was published"));
    },
  },
  created() {
    this.items = RedactorUtils.getTutorials();
    console.log("ITEMS: ", this.items);
  }
};
</script>